const formatSymbol = symbol => {
  return symbol.toLowerCase().replace(/^([a-z]{3})([a-z]{3})$/, '$1-$2');
};

export { formatSymbol };
